export const welcomeHeadingSx = {
  textAlign: 'center',
  marginBottom: '24px',
};

export const welcomeContentSx = {
  padding: '0px 24px',
};

export const welcomeBtnContainerSx = {
  display: 'flex',
  justifyContent: 'space-around',
  margin: '20px 0px 24px 0px',
};

export const confirmationBtnSx = { width: '50%' };
